class DownloadManager {
    constructor() {
        this.downloads = {};
    }

    addDownload(download) {
        this.downloads = { ...this.downloads, ...download };
    }

    cancelAllDownloads() {
        Object.values(this.downloads).forEach(download => download.cancelDownload());
        this.downloads = {};
    }
    delDownload(index) {
        if (this.downloads[index]) {
            delete this.downloads[index];
        }
    }
    cancelDownload(index) {
        console.log(this.downloads)
        if (this.downloads[index]) {
            this.downloads[index].cancelDownload();
            delete this.downloads[index];
        }
        console.log(this.downloads)
    }
}
export default DownloadManager;